import script from "./AchievementsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AchievementsCard.vue?vue&type=script&setup=true&lang=js"

import "./AchievementsCard.vue?vue&type=style&index=0&id=126ac616&lang=scss"

const __exports__ = script;

export default __exports__